<template>
  <div class="bannerImg container-fuild text-center" ref="banner">
    <img :src="imgUrl" alt="banner图" />
    <div class="content">
      <h1 class="text wow zoomIn">{{ bannerText }}</h1>
      <div v-if="questionText != ''" class="td_box_1 wow bounceInUp" v-html="questionText"></div>
      <div class="td_box">
        <div class="td_item wow bounceInUp" :data-wow-delay="item.time" data-wow-duration="1.4s" v-for="(item, index) in tdList" :key="index">
          <div>{{ item.td1 }}</div>
          <!-- <div>{{ item.td2 }}</div> -->
        </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  props: {
    imgUrl: {
      type: String,
      default() {
        return "";
      },
    },
    bannerText: {
      type: String,
      default() {
        return "";
      },
    },
    questionText: {
      type: String,
      default() {
        return "";
      },
    },
    tdList: {
      type: Array,
      default() {
        return []
      }
    },
    flag: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
    return {
      bannerHeight: 0,
    }
  },
  mounted() {
    if (this.flag) {
      let timer = ''
      timer = setInterval(() => {
        if (this.$refs.banner.offsetHeight) {
          this.bannerHeight = this.$refs.banner.offsetHeight
          clearInterval(timer);
          timer = null;
        }
      }, 100)
    }

  }
};
</script>
<style lang="less">
.bannerImg {
  color: #000;
  font-weight: bold;
  font-size: 30px;
  position: relative;

  img {
    max-width: 100%;
    width: 100%;
    height: 100%;
  }

  .content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80%;

    .text {
      width: 100%;
      font-weight: bold;
      letter-spacing: 15px;
      text-shadow: 0 0 6px #000;
      color: #fff;
      font-size: 70px;
      text-align: center;
      margin-bottom: 60px;
    }

    .td_box_1 {
      color: #fff;
      text-align: center;
      font-size: 32px;
      text-shadow: 0 0 6px #000;
      margin-bottom: 60px;
    }

    .td_box {
      display: flex;
      color: #fff;
      justify-content: center;

      .td_item {
        font-size: 38px;
        text-shadow: 0 0 6px #000;

        &:nth-child(2n) {
          margin-left: 100px;
          margin-right: 100px;
        }
      }
    }
  }
}

@media (max-width: 991px) {
  .bannerImg {
    .content {
      width: 90%;

      .text {
        font-size: 24px;
        margin-bottom: 10px;
        letter-spacing: 6px;
      }

      .td_box_1 {
        font-size: 13px;
        margin-bottom: 6px;
        justify-content: center;

      }

      .td_box {

        .td_item {
          font-size: 14px;
          &:nth-child(2n) {
            margin-left: 30px;
            margin-right: 30px;
          }
        }
      }
    }





  }
}
</style>



// WEBPACK FOOTER //
// src/components/banner.vue